import React from "react";
import { Button, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuthContext } from "contexts";
import { useTranslation } from "react-i18next";

const LogoutUI = ({ showName = false }) => {
  const { t } = useTranslation("layout");
  const { logout } = useAuthContext();

  return (
    <>
      {showName ? (
        <Button startIcon={<LogoutIcon />} variant="contained" onClick={logout}>
          {t("logout")}
        </Button>
      ) : (
        <IconButton onClick={logout} aria-label={t("logout")}>
          <LogoutIcon />
        </IconButton>
      )}
    </>
  );
};

export default React.memo(LogoutUI);
